import lang from "./lang.json";

export const langDiv = navigator.language || navigator.userLanguage;

export let content = {};

if (
  (localStorage.getItem("language") === "ar" &&
    localStorage.getItem("language")) ||
  (langDiv === "ar" && !localStorage.getItem("language"))
) {
  content = lang.validate.ar;
} else {
  content = lang.validate.en;
}
